// extracted by mini-css-extract-plugin
export default {"image":"EmptySearch__image--3_t7e"};